window.Popper = require('popper.js').default

// Глобальное объявление jQuery
import $ from 'jquery'

window.$ = $
window.jQuery = $

// Глобальное объявление Bootstrap
import * as bootstrap from 'bootstrap'

window.bootstrap = bootstrap

import { tns } from 'tiny-slider/src/tiny-slider'
import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.esm.js'
import { Carousel } from '@fancyapps/ui/dist/carousel/carousel.esm.js'
import { Thumbs } from '@fancyapps/ui/dist/carousel/carousel.thumbs.esm.js'
import SlickImageCompare from 'slick-image-compare'
import lozad from 'lozad'

var jQueryBridget = require('jquery-bridget')
var Masonry = require('masonry-layout')
// make Masonry a jQuery plugin
jQueryBridget('masonry', Masonry, $)
$(function () {
  // Сохраняем оригинальный конструктор
  const OriginalSlickImageCompare = SlickImageCompare

  // Переопределяем конструктор
  function ModifiedSlickImageCompare (container, options) {
    // Вызываем оригинальный конструктор
    const instance = new OriginalSlickImageCompare(container, options)

    if (instance.error) return instance

    // Переопределяем метод _appEvents чтобы изменить поведение событий
    const originalAppEvents = instance._appEvents

    instance._appEvents = function (add = true) {
      if (add && this._initialized) {
        // Вызываем оригинальный метод для базовой настройки
        originalAppEvents.call(this, false) // Сначала удаляем все события

        // Настраиваем события ТОЛЬКО для круга
        this._setupCircleOnlyEvents()

        // Добавляем resize событие
        const method = add ? 'addEventListener' : 'removeEventListener'
        window[method]('resize', this._dimensions)
      } else {
        originalAppEvents.call(this, add)
      }
    }

    // Новый метод для настройки событий только для круга
    instance._setupCircleOnlyEvents = function () {
      if (!this._dragHandle) return

      const $container = $(this.element)
      const $circle = $(this._dragHandle).find('.sic-circle')

      if ($circle.length === 0) return

      // Блокируем все события на основном контейнере
      $container.css('pointer-events', 'none')
      $container.off('mousedown touchstart click')

      // Разрешаем события только для круга
      $circle.css('pointer-events', 'auto')

      // Обработчики для круга
      $circle.on('mousedown touchstart', (e) => {
        e.preventDefault()
        e.stopPropagation()

        // Вызываем оригинальный обработчик перетаскивания
        this._dragStart.call(this, e)
      })

      // Блокируем клики в любом другом месте
      $container.on('mousedown touchstart click', (e) => {
        if (!$(e.target).closest('.sic-circle').length) {
          e.preventDefault()
          e.stopPropagation()
          return false
        }
      })
    }

    return instance
  }

  // Заменяем оригинальный конструктор
  window.SlickImageCompare = ModifiedSlickImageCompare

  // Инициализируем с модифицированным поведением
  new ModifiedSlickImageCompare('#slick-image-compare')
})

$.fn.tagNameLowerCase = function () {
  return this.prop('tagName').toLowerCase()
}
//картинки в натуральную величину загружаются по мере появления на экране (Intersection Observer используется)
document.addEventListener('DOMContentLoaded', function () {
  const observer = lozad('.lozad', {
    loaded: function (el) {
      el.classList.add('loaded')
    }
  })
  observer.observe()
})

$(function () {

  // Проверяем, существует ли на странице виджет уведомления о cookies
  if ($('#cookies-widget').length) {
    if (!getCookie('cookieAlertShowed')) {
      $('#cookies-widget').addClass('show')
    }
  }

  // Обработчик клика на кнопку подтверждения cookies
  $('#cookies-widget #cookies-ok').click(function () {
    setCookie('cookieAlertShowed', true, 365)
    $('#cookies-widget').removeClass('show')
  })

  // Инициализация при загрузке страницы
  $('.carousel.palette-product-slider').each(function () {
    updateCarouselControls(this)
  }).on('slid.bs.carousel', function () {
    updateCarouselControls(this)
  })

  // Предотвращаем клик по отключенным кнопкам
  $('.carousel-control.disabled').click(function (e) {
    e.preventDefault()
    e.stopPropagation()
    return false
  })

  $.each($('[data-bs-ride="false"]'), (key, element) => {
    const carousel = bootstrap.Carousel.getOrCreateInstance(element)
    carousel.pause()
  })

  // Синхронизация слайдеров
  $('[data-slider-group]').on('click', function (e) {
    if (e.target.tagName !== 'A') {
      e.preventDefault()
      const groupName = $(this).data('slider-group')
      const direction = $(this).data('bs-slide')

      $(`.palette-product-slider[data-slider-group="${groupName}"]`).each(function () {
        const carousel = bootstrap.Carousel.getInstance(this)
        if (carousel) {
          if (direction === 'prev') {
            carousel.prev()
          } else if (direction === 'next') {
            carousel.next()
          }
        }
      })
    }
  })

  // Синхронизация при переключении слайдов
  $('.palette-product-slider').on('slid.bs.carousel', function (e) {
    const groupName = $(this).data('slider-group')
    if (!groupName) return

    const activeIndex = e.to

    $(`.palette-product-slider[data-slider-group="${groupName}"]`).each(function () {
      if (this !== e.target) {
        const carousel = bootstrap.Carousel.getInstance(this)
        if (carousel) {
          carousel.to(activeIndex)
        }
      }
    })
  })

  Fancybox.bind('[data-fancybox]', {
    Thumbs: {
      type: 'classic',
    },
  })

  if ($('#f-carousel').length) {
    Fancybox.bind('[data-fancybox="gallery"]', {
      Thumbs: {
        type: 'classic',
      },
    })

    new Carousel($('#f-carousel')[0], {
      Dots: false,
      Navigation: false,
      Thumbs: {
        type: 'classic',
        on: {
          ready: function (thumbsInstance) {
            const trackThumbFullWidth = jQuery(thumbsInstance.track.firstChild).outerWidth(true),
              slidesCount = thumbsInstance.carousel.slides.length
            if (trackThumbFullWidth * slidesCount < thumbsInstance.carousel.viewportDim) {
              jQuery(thumbsInstance.container).addClass('no-transform')
            }
          }
        }
      },
    }, { Thumbs })
  }

  const scroll = $(window).scrollTop(),
    scrollTriggerHeight = 50

  if (scroll >= scrollTriggerHeight) {
    $('body').addClass('sticky-menu-visible')
  }

  $(window).on('scroll', function () {
    const scroll = $(window).scrollTop()

    if (scroll >= scrollTriggerHeight) {
      $('body').addClass('sticky-menu-visible')
    } else {
      $('body').removeClass('sticky-menu-visible')
    }
  })

  $('#dropdownMenuLinkMain').on({
    mouseenter: function (e) {
      const dropdownToggle = $(this.dataset.dropdownTarget),
        dropdownMenu = dropdownToggle.find('.dropdown-menu')
      if (!dropdownToggle.hasClass('show') && !dropdownMenu.hasClass('show')) { // Ignore collapsed navbar
        dropdownToggle.addClass('show')
        dropdownMenu.addClass('show')
        dropdownToggle.on({
          mouseleave: function (e) {
            const dropdownToggle = $(e.currentTarget),
              dropdownMenu = dropdownToggle.find('.dropdown-menu')
            // console.log(this)
            if (dropdownToggle.hasClass('show') && dropdownMenu.hasClass('show')) { // Ignore collapsed navbar
              dropdownToggle.removeClass('show')
              dropdownMenu.removeClass('show')
            }
          }
        })
      }
    }
  })

  $('[data-dropdown-target]').on('click', function () {
    $($(this).attr('data-dropdown-target')).dropdown('toggle')
  })

  $('nav.navbar button[data-bs-toggle="tab"]').on('show.bs.tab', function (event) {
    const tabContent = $(event.target).closest('.tab-content')
    tabContent.find('.tab-pane.fade').removeClass('active', 'show')
    tabContent.find('.item-link.active').removeClass('active')
    tabContent.find('button[data-bs-toggle="tab"]').removeClass('active')
  })

  if ($('.tiny-slider').length) {
    $.each($('.tiny-slider'), function (key, tinySliderNode) {
      const tinySlider = $(tinySliderNode)
      let itemsSlider = tns({
        container: tinySlider.find('.products-items-slider-box')[0],
        controlsContainer: tinySlider.find('.steps-nav')[0],
        prevButton: tinySlider.find('.steps-nav-prev')[0],
        nextButton: tinySlider.find('.steps-nav-next')[0],
        loop: false,
        animateDelay: 200,
        responsive: {
          '360': {
            'items': 2
          },
          '576': {
            'items': 2
          },
          '1400': {
            'items': 3
          },
          '1900': {
            'items': 4
          }
        },
        slideBy: 'page',
        navPosition: 'bottom',
        swipeAngle: 20,
        mouseDrag: true,
        speed: 400,
        onInit: function (data) {
          setPages(data)
        }
      })

      let stepsSliderPageNav = function (data, eventName) {
        setPages(data)
      }

      function setPages (data) {
        // $('#steps-nav-next').prop('disabled', false);
        // if(data.displayIndex - 1 + data.slideBy === data.slideCount){
        //   $('#steps-nav-next').prop('disabled', true);
        // }
        if (tinySlider.find('.pages').length) {
          tinySlider.find('.pages .from').text(data.displayIndex)
          tinySlider.find('.pages .to').text(data.displayIndex - 1 + data.slideBy)
          tinySlider.find('.pages .total').text(data.slideCount)
        }
      }

      itemsSlider.events.on('indexChanged', stepsSliderPageNav)
    })
  }

  $('.lazyload').each(function () {
    let el = $(this)
    if (el.data('src')) {
      el.attr('src', el.data('src'))
      if (el.tagNameLowerCase() == 'source' && el.parent().tagNameLowerCase() == 'video') {
        el.parent()[0].load()
        el.parent()[0].play()
      }
    }
  })

  const videoModal = document.getElementById('modal-video')
  if (videoModal) {// сейчас модалка с громадным видео есть на главной странице
    videoModal.addEventListener('show.bs.modal', event => {
      let el = $('#modal-video source')
      if (el.data('src')) {
        el.attr('src', el.data('src'))
        if (el.tagNameLowerCase() == 'source' && el.parent().tagNameLowerCase() == 'video') {
          el.parent()[0].load()
          el.parent()[0].play()
        }
      }
    })
    //видео нужно остановить при закрытии модалки (иначе видео продолжает играть в фоне)
    videoModal.addEventListener('hide.bs.modal', event => {
      $('#modal-video video').trigger('pause')
    })
  }

  $('[data-toggle="offcanvas"]').on('click', function () {
    $('.offcanvas-collapse').toggleClass('open')
    $('body').toggleClass('mobile-navbar-show')
  })

  $('body > .pattern').on('click', function () {
    $('.navbar-icon-close').click()
  })

  // Back to Top
  $(document).scroll(function () {
    if ($(this).scrollTop() > 1) {
      $('.scroll-up').removeClass('hidden').addClass('show')
    } else {
      $('.scroll-up').removeClass('show').addClass('hidden')
    }
  })

  $('.scroll-up').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 800)
    return false
  })

  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('[name="_token"]').attr('value')
    }
  })
  //форма отправки 1 статьи блога на указанную почту
  $('.send-article-form').submit(function (e) {
    e.preventDefault()
    ym && ym(54018781, 'reachGoal', 'BRL')
    var form = $(this),
      validate = validateForm(form)
    if (validate) {
      var arrayFormData = getAssocArray(form)
      form.find('button').attr('disabled', 'disabled')
      arrayFormData['page'] = window.location.pathname === '/' ? '/index/' : window.location.pathname
      $.ajax({
        type: 'POST',
        url: '/sendarticle',
        context: form,
        data: arrayFormData,
        success: function (data) {
          form.find('button').removeAttr('disabled')
          $('.article-blog .form-content').fadeOut(150)
          $('.article-blog .success-result').fadeIn(150)
        },
        error: function (err) {
          form.find('button').removeAttr('disabled')
          console.error(err)
          if (err.status === 422 && err.responseJSON && err.responseJSON.message) {
            alert(err.responseJSON.message)
          } else {
            alert('Error: ' + err)//@todo сделать красивое окно
          }
        }
      })
    }
  })
  //форма в блоге внизу статьи - подписка на новые статьи
  $('.subscribe-article-form').submit(function (e) {
    ym && ym(54018781, 'reachGoal', 'BRL')
    e.preventDefault()
    var $form = $(this)
    $form.find('button').attr('disabled', 'disabled')
    $.ajax({
      type: 'POST',
      url: $form.attr('action'),
      data: $form.serialize(),
      success: function (data) {
        $form.find('button').removeAttr('disabled')
        $form[0].reset()
        $('#successSubscribeModal').modal('show')
        setTimeout(function () {
          $('#successSubscribeModal').modal('hide')
        }, 5000)
      },
      error: function (e) {
        $form.find('button').removeAttr('disabled')
        console.error(e)
        var message = 'responseJSON' in e ? e.responseJSON.message : 'Произошла ошибка подписки :('
        alert(message)
      }
    })
  })

  function validateForm (form) {
    var validate = true
    form.find('input, textarea, select').each(function (key, item) {
      var obj = $(item)
      if (obj.attr('required') === 'required' || obj.attr('required')) {
        if (obj.val() !== '' || obj.prop('checked')) {
          validate = !validate ? validate : true
          obj.removeClass('is-invalid')
        } else {
          validate = false
          obj.addClass('is-invalid')
        }
        if (obj.attr('type') == 'email' && !validateEmail(obj.val())) {
          validate = false
          obj.addClass('is-invalid')
        }
        if ((obj.attr('name') === 'phone' || obj.attr('name') === 'tel') && !validatePhone(obj.val())) {
          validate = false
          obj.addClass('is-invalid')
        }
      }
    })
    return validate
  }

  $('.no-reading-button').click(function (e) {
    e.preventDefault()
    var button = $(this)
    if (!button.hasClass('active')) {
      $('.article-blog .got-time').show()
      $('.article-blog .no-time').hide()
      $('.article-blog .form-body').fadeIn(200)
      button.addClass('active')
    } else {
      $('.article-blog .got-time').hide()
      $('.article-blog .no-time').show()
      $('.article-blog .form-body').fadeOut(200)
      button.removeClass('active')
    }
  })

  $('.showMore').click(function (e) {
    e.preventDefault()

    let showMoreBtnNode = $(this),
      currentPage = eval(this.dataset.currentPage)

    if (currentPage != undefined) {
      $('.articles-news .loading-container').fadeIn(150)
      $.ajax({
        type: 'GET',
        url: window.location.href + '?page=' + (currentPage + 1),
        dataType: 'html',
        success: function (data) {
          $('.articles-news .loading-container').hide()
          var articles = $('<div/>').html(data).find('.articles-news .row .col')
          $('.articles-news .row').append(articles)

          new IOlazy({
            image: '.lazyload2'
          })
          if ((currentPage + 1) == showMoreBtnNode.data('page-count')) {
            showMoreBtnNode.hide()
          }

          showMoreBtnNode.attr('data-current-page', (currentPage + 1))
        },
        error: function () {
          console.log('error')
        }
      })
    }
  })

  $('.select__trigger').click(function () {
    $(this).parents('.select').find('.select__dropdown').toggle()
  })

  $('[name="phone"]').on('focus', function () {
    if ($(this).val() === '')
      $(this).val('+')
  })

  $('[name="phone"]').on('focusout', function () {
    if ($(this).val() === '+')
      $(this).val('')
  })

  $('[name="phone"]').on('keydown', function (e) {
    if (e.keyCode == 8 && $('[name="phone"]').is(':focus') && $('[name="phone"]').val().length < 2) {
      e.preventDefault()
    }
  })

  $('[name="phone"]').on('input', (e) => {
    e.target.value = e.target.value.replace(/[^+\d]/g, '')
  })

  $(document).mouseup(function (e) { // событие клика по веб-документу
    var div = $('.select__dropdown') // тут указываем ID элемента
    if (!div.is(e.target) // если клик был не по нашему блоку
      && div.has(e.target).length === 0) { // и не по его дочерним элементам
      div.hide() // скрываем его
    }
  })

  var $grid

  if ($(window).width() >= 768)
    $grid = $('.grid').masonry({
      itemSelector: '.grid-item',
      columnWidth: 340,
      gutter: 20,
      fitWidth: true
    })

  $('.copy-link').click(function (e) {
    e.preventDefault()
    copytext(window.location.href)
    $('.link-text').hide()
    $('.copy-success').fadeIn(150)
    $(this).css('pointer-events', 'none')
    $('.article-blog .article-body .social .share-icon').addClass('done')
    setTimeout(function () {
      $('.copy-success').hide()
      $('.link-text').fadeIn(150)
      $('.copy-link').css('pointer-events', 'all')
      $('.article-blog .article-body .social .share-icon').removeClass('done')
    }, 3000)
  })

  if ($('.palette-box').length) {
    $('.palette-box.folded .expand').click(function (e) {
      e.preventDefault()
      const paletteBox = $(e.target.closest('.palette-box'))
      paletteBox.removeClass('folded')
    })
    $('.palette-box .color-item').click(function (e) {
      e.preventDefault()
      const colorItem = $(e.target)
      const productItem = colorItem.closest('a.standard-product-item')
      let mainImg = productItem.find('img.main-item-img')
      if (productItem.hasClass('is-double-height')) {
        mainImg = productItem.find('img.main-item-img.double-height-main-img')
      }
      const itemTitle = productItem.find('.item-title')
      const colorsBox = productItem.find('.colors-box')

      productItem.attr('href', productItem.attr('href').replaceAll(productItem.data('slug'), colorItem.data('slug')))
      itemTitle.text(colorItem.data('title'))

      mainImg.attr('src', mainImg.attr('src').replaceAll(productItem.data('slug'), colorItem.data('slug')))
      if (mainImg.attr('srcset')) {
        mainImg.attr('srcset', mainImg.attr('srcset').replaceAll(productItem.data('slug'), colorItem.data('slug')))
        mainImg.data('srcset', mainImg.data('srcset').replaceAll(productItem.data('slug'), colorItem.data('slug')))
      }
      mainImg.removeClass('loaded')
      mainImg.data('loaded', false)

      productItem.data('slug', colorItem.data('slug'))
      productItem.data('title', colorItem.data('title'))
      colorsBox.find('.color-item').removeClass('active')
      colorItem.addClass('active')
    })
  }

})

$(document).ready(function () {
  if (window.screen.width > 991)
    $(window).scroll(function () {
      var position = $(this).scrollTop()

      $('.article-text h2').each(function () {
        var target = $(this).offset().top

        var id = $(this).attr('id')
        if (position >= target - 80) {
          $('.article-navigation li a.active').removeClass('active')
          $('.article-navigation li a[href="#' + id + '"]').addClass('active')
        }
      })
    })
})

// $(window).on("load", function () {
//     $('.events_slider').slick({
//         prevArrow: '<button type="button" class="slick-prev"></button>',
//         nextArrow: '<button type="button" class="slick-next"></button>'
//     });
// });

function updateCarouselControls (carousel) {
  var $this = $(carousel)
  var $prevControl = $this.find('.carousel-control.carousel-control-prev')
  var $nextControl = $this.find('.carousel-control.carousel-control-next')
  var $firstItem = $this.find('.carousel-inner .carousel-item:first')
  var $lastItem = $this.find('.carousel-inner .carousel-item:last')
  var $activeItem = $this.find('.carousel-inner .carousel-item.active')

  // Сбрасываем все состояния
  $prevControl.removeClass('disabled')
  $nextControl.removeClass('disabled')
  $prevControl.prop('disabled', false)
  $nextControl.prop('disabled', false)

  // Проверяем первый слайд
  if ($activeItem.is($firstItem)) {
    $prevControl.addClass('disabled')
    $prevControl.prop('disabled', true)
  }

  // Проверяем последний слайд
  if ($activeItem.is($lastItem)) {
    $nextControl.addClass('disabled')
    $nextControl.prop('disabled', true)
  }
}

function getAssocArray (form) {
  var resultObj = {}

  $.each($(form).serializeArray(), function (key, row) {
    resultObj[row.name] = row.value
  })

  return resultObj
}

function copytext (el) {
  var $tmp = $('<textarea>')
  $('body').append($tmp)
  $tmp.val(el).select()
  document.execCommand('copy')
  $tmp.remove()
}

function validateEmail (email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

function validatePhone (phone) {
  const rePhone = phone.replace(/[^+\d]/g, '')
  return rePhone.length > 5
}

// var iconCounter = 2;
// var interval = setInterval(function () {
//     iconChanger()
// }, 2000);
//
// function iconChanger() {
//     if (iconCounter > $('.multibutton .main_icons .icon_item').length) iconCounter = 1;
//     $('.multibutton .active.icon_item').toggleClass('active');
//     $('.multibutton .main_icons .icon_item:nth-child(' + iconCounter + ')').toggleClass('active');
//     iconCounter++;
// }

window.onloadRecaptchaCallback = function () {

}

function setCookie (cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}
